import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  formInput: {
    maxWidth: "100px",
  },
  listButton: {
    color: "white",
    background: "#64b5f6",
    textTransform: "capitalize",
    borderRadius: 0,
    width: "80px",
    "&:hover": {
      background: "#54a6e8",
    },
  },
  title: {
    marginBottom: theme.spacing(0.8),
    background: "#eceaea",
    color: "#000",
    height: "3.5em",
    "& .MuiTypography-root": {
      fontSize: "medium",
      textTransform: "capitalize",
      fontWeight: "lighter",
      marginLeft: theme.spacing(1),
    },
  },
  formContainer: {
    background: "#ffffff",
  },
  divider: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2),
  },
  showMandatory: {
    "& .MuiTypography-root": {
      color: "#FF0000",
      textTransform: "none",
      fontWeight: "lighter",
    },
    justifyContent: "flex-end",
    [theme.breakpoints.down("sm")]: {
      justifyContent: "flex-start",
    },
  },
}));

export default useStyles;
